import type {PermissionType} from '@hconnect/apiclient'
import {useMemo} from 'react'

import {checkPermissionsByDataScope} from '../helpers/checkPermissionsByDataScope'

import {usePermissionsParsedQuery} from './queries'

interface PlantContext {
  plantId: string
  countryId: string
}

interface UsePermissionParams {
  plantContext: PlantContext | undefined
  permissionTypes: PermissionType[]
}

export const usePermission = ({plantContext, permissionTypes}: UsePermissionParams): boolean => {
  const {data: permissions} = usePermissionsParsedQuery(permissionTypes)
  return useMemo(() => {
    if (!permissions || !plantContext) {
      return false
    }
    return checkPermissionsByDataScope(permissions, plantContext, permissionTypes)
  }, [permissions, plantContext, permissionTypes])
}
